import React, { createContext, useContext, useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import { apiHeader, BaseURL } from '../config/apiUrl';
import { Post } from '../Axios/AxiosFunctions';

const LogoContext = createContext({
    logo: null,
    setLogo: () => { }
});

export const useLogo = () => useContext(LogoContext);

export const LogoProvider = ({ children }) => {
    const [logo, setLogo] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchLogo = async () => {
            const storedLogo = localStorage.getItem('frontend_companyLogo');
            const storedPhone = localStorage.getItem('frontend_companyPhone');
            const storedWebsite = localStorage.getItem('frontend_companyWebsite');
            if (storedLogo && storedLogo != 'null' && storedLogo != 'undefined' && storedPhone && storedPhone != 'null' && storedPhone != 'undefined' && storedWebsite && storedWebsite != 'null' && storedWebsite != 'undefined') {
                setLogo(storedLogo);
                setLoading(false);
                return;
            }

            try {
                const url = BaseURL('company/logo');
                const headers = apiHeader();
                const response = await Post(url, {}, headers);
                const logoUrl = response.data.logoUrl;
                const phone = response.data.phone;
                const website = response.data.website;
                const formattedPhone = phone?.replace(
                    /^(\d{3})\s*(\d{3})\s*(\d{4})$/,
                    '$1-$2-$3',
                );
                console.log(formattedPhone)
                localStorage.setItem('frontend_companyLogo', logoUrl);
                localStorage.setItem('frontend_companyPhone', formattedPhone);
                localStorage.setItem('frontend_companyWebsite', website);
                setLogo(logoUrl);
            } catch (error) {
                console.error('Error fetching logo:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchLogo();
    }, []);

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh'
            }}>
                <CircularProgress />
            </div>
        );
    }

    return (
        <LogoContext.Provider value={{ logo, setLogo }}>
            {children}
        </LogoContext.Provider>
    );
};
